<template>
  <div class="table-container">
    <table class="table is-striped is-narrow is-hoverable is-fullwidth">
      <thead>
        <tr class="is-uppercase is-size-4">
          <th>{{ $t('domains.my_domain.heading_name') }}</th>
          <th>{{ $t('domains.my_domain.heading_status') }}</th>
          <th>{{ $t('domains.my_domain.heading_manage') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="is-size-5">
          <th>myservices.web.com</th>
          <th class="active">
            <font-awesome-icon
              icon="check-circle"
            />
            {{ $t('common.active') }}
          </th>
          <th>
            <a class="button is-uppercase is-large">
              {{ $t('domains.domain_manage_button') }}
            </a>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {

  name: 'List'
}
</script>
